import React from 'react';

type PersonFieldLabelProps = {
  htmlFor: string;
  children: React.ReactNode;
};

// The in-flow label the Person form draws above each control.
const PersonFieldLabel = ({ htmlFor, children }: PersonFieldLabelProps) => (
  <label
    htmlFor={htmlFor}
    className="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2"
  >
    {children}
  </label>
);

export default PersonFieldLabel;
